/**
 * Estado das campanhas de ligação (Comercial I / II / III).
 *
 * `callData` é preenchido pela tabulação do operador no hangup e consumido
 * pelo componente da campanha ativa para gravar o resultado da ligação.
 * `startCampaign` funciona como um "sinal": alterná-lo avisa a campanha de que
 * a ligação terminou e ela deve avançar para o próximo cliente.
 */
const state = {
    startCampaign: false,
    callData: {
        tab: null,
        tab_obs: null,
        call_id: null,
        scheduling_datetime: null,
    }
}

const getters = {
    getStartCampaign: state => state.startCampaign,
    getCallData: state => state.callData,
}

const mutations = {
    mutationStartCampaign: (state) => {
        state.startCampaign = !state.startCampaign;
    },
    mutationCallData: (state, data) => {
        state.callData.tab = data.tab !== undefined ? data.tab : state.callData.tab;
        state.callData.tab_obs = data.tab_obs !== undefined ? data.tab_obs : state.callData.tab_obs;
        state.callData.call_id = data.call_id !== undefined ? data.call_id : state.callData.call_id;
        state.callData.scheduling_datetime = data.scheduling_datetime !== undefined ? data.scheduling_datetime : state.callData.scheduling_datetime;
    },
}

const actions = {
    async setStartCampaign({ commit }) {
        commit('mutationStartCampaign');
    },
    async setCallData({ commit }, data) {
        commit('mutationCallData', data);
    },
}

export default {
    getters,
    mutations,
    actions,
    state
}
